<template>
  <div class="footer">
    <div class="copy-right">© 2023 Gamania Group</div>
    <div class="container"> <!-- Frame 48097822 -->
      <div class="footer-logo-mobile">
        <img class="logo-img" :id="footerComicsId" @click="link(comics_url, true)" src="/images/anniversary2023/footer/footer_漫畫星.svg" />
        <img class="logo-img" :id="footerNovelsId" @click="link(novels_url, true)" src="/images/anniversary2023/footer/footer_文學星.svg" />
      </div>
      <div class="footer-logo-desktop">
        <img class="logo-img-d" :id="footerComicsId" @click="link(comics_url, true)" src="/images/anniversary2023/footer/footer_漫畫星_d.svg" />
        <img class="logo-img-d" :id="footerNovelsId" @click="link(novels_url, true)" src="/images/anniversary2023/footer/footer_文學星_d.svg" />
      </div>
      <div class="social-link">
        <div class="g-link-mobile">
          <div @click="link('https://www.instagram.com/comic.funhere/', true)">
            <img :id="footerNomics_IGId" class="g-link-mobile-img" src="/images/anniversary2023/footer/m-ig-link.svg" />
          </div>
          <div @click="link('https://www.facebook.com/funnovel/', true)">
            <img :id="footerNovels_FBId" class="g-link-mobile-img" src="/images/anniversary2023/footer/m-facebook-link.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="g-link-desktop">
      <div @click="link('https://www.instagram.com/comic.funhere/', true)">
        <img :id="footerNomics_IGId_qr" src="/images/anniversary2023/footer/漫畫星官方IG.svg" />
      </div>
      <div @click="link('https://www.facebook.com/funnovel/', true)">
        <img :id="footerNovels_FBId_qr" src="/images/anniversary2023/footer/文學星FB粉絲團.svg" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import * as common from "@/api/common";
import { openLink } from "@/lib/Utils";

export default {
  name: "Footer",
  props: {
    msg: String,
    prefix: String,
  },
  data() {
    return {
      footerComicsId: this.prefix + "footer_comics",
      footerNovelsId: this.prefix + "footer_novels",
      footerNomics_IGId_qr: this.prefix + "footer_comics_IG_qrcode",
      footerNovels_FBId_qr: this.prefix + "footer_novels_FB_qrcode",
      footerNomics_IGId: this.prefix + "footer_comics_IG",
      footerNovels_FBId: this.prefix + "footer_novels_FB",
      comics_url: import.meta.env.VITE_COMICS_URL, // 漫畫星轉址
      novels_url: import.meta.env.VITE_NOVELS_URL, // 文學星轉址
    };
  },
  methods: {
    // 開啟外部連結
    link(url: string, open: boolean) {
      openLink({ url: url, open: open });
    },
  },
};
</script>

<style scoped>
.footer {
  width: 100vw;
  text-align: left;
  background-color: black;
  position:relative;
  display:block;
  border: 2px solid white;
  border-bottom: none;
  border-left: none;
  border-right: none;
  height: 200px;
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    height: 250px !important;
  }
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    height: 200px !important;
  }
}
.copy-right {
  width: 100%;
  position: relative;
  color: white;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  line-height: 23.17px;
  top: 167px;
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    top: 200px !important; 
  }
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    top: 167px !important;
  }
}
.container{
  margin: 20px 0px 16px 0px !important;
  display: flex;
  flex-direction: column;
  align-items: center; /* 置中設定 */
  justify-content: center;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    width: 100% !important;
    display:flex !important;
    flex-direction: column !important;
    align-items: center !important; /* 置中設定 */
  }
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    margin: 20px 0px 16px 0px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important; /* 置中設定 */
    justify-content: center !important;
    position: absolute !important;
    top: 0px !important;
    left: 0px !important;
    width: 100% !important;
  }
}
.footer-logo-mobile{
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    display: none;
  }
}
.footer-logo-desktop{
  display:none;
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    display:inline-block;
  }
}
.logo-img{
  height: 36px;
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    height: 36px !important;
  }
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    margin-top:32px !important;
    height:36.23px !important;
  }
}
.logo-img-d{
  height: 38px;
  /*如果螢幕寬度為 1031px 以下，就套用 css 設定*/
  @media screen and (max-width: 1031px) {
    height: 18px !important;
  }
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    margin: 45px 18px 0px 18px !important;
    height:38px !important;
  }
}
.social-link{
  /* margin-top: 20px; */
}
.g-link-mobile{
  /*如果螢幕寬度為 1032px 以上 ，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    display: none;
  }
}
.g-link-mobile-img{
  margin-top: 16px;
  height:21px;
}
.g-link-desktop{
  position: absolute;
  right: 100px;
  top: 80px;
  gap: 100px;
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
  display: none;
  /*如果螢幕寬度為 1032px 以上，就套用 css 設定*/
  @media screen and (min-width: 1032px) {
    display: flex;
  }
}

</style>
